import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useCafe3dStore } from '@/stores/cafe3dStore';
import { BeanCounter } from './BeanCounter';

export function RevenueTicker() {
  const { t } = useTranslation();
  const revenueToday = useCafe3dStore((s) => s.revenueToday);
  const lastDelta = useCafe3dStore((s) => s.lastRevenueDelta);
  const isRushHour = useCafe3dStore((s) => s.isRushHour);
  const [showDelta, setShowDelta] = useState(0);

  useEffect(() => {
    if (lastDelta > 0) {
      setShowDelta(Date.now());
    }
  }, [lastDelta, revenueToday]);

  return (
    <div
      className={`h-8 px-4 flex items-center gap-2 game-ui transition-colors ${
        isRushHour ? 'bg-yellow-light/20' : 'bg-cream-100/80'
      } border-b border-coffee-700/5`}
    >
      {isRushHour ? (
        <>
          <span className="text-sm">🔥</span>
          <span className="text-xs font-medium text-coffee-900">{t('hud.rush_hour')}</span>
        </>
      ) : (
        <>
          <span className="text-sm">📈</span>
          <span className="text-xs text-coffee-700">{t('hud.revenue_today')}</span>
        </>
      )}
      <BeanCounter
        value={revenueToday}
        className="text-sm font-baloo font-semibold text-coffee-900"
      />
      <span className="text-xs text-coffee-700">{t('hud.bean')}</span>
      {showDelta > 0 && Date.now() - showDelta < 1500 && (
        <span
          key={showDelta}
          className="text-xs font-baloo text-green-leaf animate-slide-fade"
        >
          +{lastDelta} ↑
        </span>
      )}
    </div>
  );
}
